import * as types from '../../mutationTypes';

export default {
    async assignList({ commit }, list) {
        commit(types.ASSIGN_LIST, list);
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/quickLinks/actions.js